export default {
  data() {
    return {
      panelLoading: true,
    };
  },
};
